module.exports = __webpack_public_path__ + "SC05_Guest.244ec829.atlas";